(ns common.schema.entities.value-creation.permissions
  (:require
   [common.features.plan :as plan]
   [common.schema.entities.permission-checks :as permission-checks]))

(defn read-permissions?
  [{:keys [account-current-permissions tenant role tenant-plan]}]
  (and (plan/available :feature/value-creation-activity tenant role tenant-plan)
       (contains? (:account-modules account-current-permissions)
                  :module/value-creation-activity)))

(defn disable-permissions?
  [ctx]
  (permission-checks/activity-delete-check-fn ctx))
